
<div class="row">

    <div class="col-1 text-md-start">
        <button class="btn btn-secondary mt-1" (click)="returnToList()"> Back </button>
    </div>
    <div class="col-11 mogo-bold">
        <h1>
            @if (orderId === null) {
                <p>
                    Create Order
                </p>

            } @else {
                <p>
                    Editing Order
                </p>
            }
        </h1>
    </div>

</div>



<app-order-upsert-form [freightPayers]="freightPayers$ | async" [orderId]="orderId">

</app-order-upsert-form>
